import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiLikesComponent } from './fi-likes.component';
import { MatButtonModule } from '@angular/material/button';
import { FiLikesService } from '@fi-app/shared/fi-likes/services/fi-likes.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { InfoIconModule } from '../info-icon/info-icon.module';
import { FiReactionPickerComponent } from './reaction-picker/fi-reaction-picker.component';
import { FiReactionsBadgeComponent } from './reactions-badge/fi-reactions-badge.component';
import { MatMenuModule } from '@angular/material/menu';
import { FiEmojiModule } from '@fi-shared/fi-emoji-button/fi-emoji.module';
import { FiEmojiMartOverlayModule } from '@fi-shared/fi-emoji-mart-overlay/fi-emoji-mart-overlay.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiAppTextSharedModule } from '../app-text';
import { FiLikesFactoryService } from '@fi-app/shared/fi-likes/services/fi-likes-factory.service';
import { FiLikesStoreService } from '@fi-app/shared/fi-likes/services/fi-likes-store.service';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        InfoIconModule,
        MatMenuModule,
        FiEmojiModule,
        FiEmojiMartOverlayModule,
        FiProfileIconModule,
        FiAppTextSharedModule,
    ],
    declarations: [FiLikesComponent, FiReactionPickerComponent, FiReactionsBadgeComponent],
    providers: [FiLikesService, FiLikesFactoryService, FiLikesStoreService],
    exports: [FiLikesComponent, FiReactionPickerComponent, FiReactionsBadgeComponent],
})
export class FiLikesModule {}
